<template>
  <div id="layoutSidenav_content">
    <main>
      <router-view/>
    </main>
    <base-app-footer/>
  </div>
</template>


<script>
export default {
  name: 'Content',

  /** mixins **/
  mixins: [],

  /** props **/
  props: {},

  /** data **/
  data() {
    return {};
  },

  /** methods**/
  methods: {},

  /**  computed  **/
  computed: {},

  /** mounted **/
  mounted() {
  },

  /** created **/
  created() {
  },

  /** watch
   searchText : {
			handler : 'fetchUserList',
			immediate : true,
		}
   **/
  watch: {},

  /** destroyed **/
  destroyed() {
  },

};
</script>

<style scoped>
span{
  font-size: 0.9em !important;
}
</style>
